import { AbstractControl, ValidatorFn } from '@angular/forms';

export function email(): ValidatorFn {
    const nameRe: RegExp = new RegExp(/^([a-zA-Z0-9_\.\-\+])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/);
    return (control: AbstractControl): { [key: string]: any } | null =>
        (control.value && !nameRe.test(control.value) && { email: true }) || null;
}
